import {
  Component,
  computed,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { CoreUtilsService } from '@core/utils/core-utils.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import {
  DataTableActionType,
  DataTableConfigurationAction,
} from '@shared/components/data-table/data-table.types';
import { RequirePermissionDirective } from '../../../directives/require-permission.directive';

@Component({
  selector: 'app-data-table-nestable-actions',
  templateUrl: './data-table-nestable-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RequirePermissionDirective,
    NgbTooltip,
    MatMenuTrigger,
    MatMenuItem,
    MatMenu,
    TranslateModule,
  ],
})
export class DataTableNestableActionsComponent {
  private coreUtilsService = inject(CoreUtilsService);

  @Input() button: DataTableConfigurationAction;
  @Input() rows: any[];
  @Input() type = '';

  DataTableActionType = DataTableActionType;
  isTablet = computed(() => this.coreUtilsService.tabletMode());

  callAction(action: (event, rows) => void, event: MouseEvent, rows: any[]) {
    event.stopPropagation();
    action?.(event, this.type === 'single' ? rows[0] : rows);
  }

  isDisabled(button) {
    let rows = this.rows;
    if (this.type === 'single') {
      rows = rows[0];
    }
    return (
      (this.type === 'single' && this.rows?.length !== 1) ||
      button?.disabled?.(rows)
    );
  }

  isInvisible(button) {
    return button?.invisible?.(
      this.type === 'single' ? this.rows?.[0] : this.rows
    );
  }
}
